/**
 * TutorAvailabilityScreen — « Ma dispo », la semaine-type du masteur (route `tutor/ma-dispo`).
 *
 * Un fil : le brouillon (`useTutorAvailabilityUi`), le view-model sur le brouillon, la lecture de la
 * semaine (`useTutorAvailabilityData`), les gestes et les écritures (`useTutorAvailabilityState`), la
 * page du DS, et la boîte d'un envoi refusé.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorAvailabilityPage } from "../../../../../../design-system/tutor"
import { tutorAvailabilityViewModel } from "../../../../view-models/tutor/Availability/tutorAvailabilityViewModel"
import { TutorSendErrorDialog } from "./TutorSendErrorDialog"
import { useTutorAvailabilityData } from "./useTutorAvailabilityData"
import { useTutorAvailabilityState, useTutorAvailabilityUi } from "./useTutorAvailabilityState"

export function TutorAvailabilityScreen() {
    const [ui, dispatchUi] = useTutorAvailabilityUi()
    const vm = useSelector((state: unknown) => tutorAvailabilityViewModel(state, ui.draft))
    const { retry } = useTutorAvailabilityData(() => dispatchUi({ type: "RESEED" }))
    const { errorMessage, onDismissError, ...gestures } = useTutorAvailabilityState(vm, ui, dispatchUi)

    return (
        <>
            <TutorAvailabilityPage
                week={vm.week}
                freshness={vm.freshness}
                cta={vm.cta}
                canSave={vm.canSave}
                startingDateOpensOn={vm.startingDateOpensOn}
                loading={vm.loading}
                error={vm.error}
                onRetry={retry}
                {...gestures}
                testID="tutor-availability"
            />
            <TutorSendErrorDialog message={errorMessage} onDismiss={onDismissError} />
        </>
    )
}
